import capitalize from 'lodash/capitalize';

import changeWeekDay from './changeWeekDay';
import getSystemTimezoneOffset from './getSystemTimezoneOffset';
import getSystemTimezoneString from './getSystemTimezoneString';

// Total number of minutes each day
const TOTAL_DAY_MINUTES = 60 * 24;

function convertToLocalTime({ day, minuteOfDay }) {
  const offset = getSystemTimezoneOffset();

  let localDay = day;
  let localMinuteOfDay = minuteOfDay + offset;

  if (localMinuteOfDay < 0) {
    localDay = changeWeekDay(localDay, -1);
    localMinuteOfDay = TOTAL_DAY_MINUTES + localMinuteOfDay;
  } else if (localMinuteOfDay > TOTAL_DAY_MINUTES) {
    localDay = changeWeekDay(localDay, 1);
    localMinuteOfDay -= TOTAL_DAY_MINUTES;
  }

  const dayString = capitalize(localDay.substring(0, 3));
  let hours = Math.floor(localMinuteOfDay / 60);
  const minutes = String(localMinuteOfDay % 60).padStart(2, '0');
  const meridian = hours >= 12 ? 'PM' : 'AM';

  hours = String(hours % 12 || 12).padStart(2, '0');

  return `${dayString} ${hours}:${minutes} ${meridian}`;
}

function stringifyAcademySchedule(schedule) {
  const dayTimeStrings = schedule.day_times.map((dayTime) => {
    return convertToLocalTime({
      day: dayTime.day,
      minuteOfDay: dayTime.minute_of_day,
    });
  });

  return dayTimeStrings.join(' | ') + ` (${getSystemTimezoneString()})`;
}

export default stringifyAcademySchedule;
